export const albumDetailPlaceholderHeights = Object.freeze([240, 330, 285, 260, 320, 220])
export const albumListPlaceholderHeights = Object.freeze([330, 440, 370, 400, 470, 320])

export const buildMasonryLayout = (heights, columnCount, gap = 0) => {
  const columns = Math.max(1, Math.floor(Number(columnCount) || 1))
  const safeGap = Math.max(0, Number(gap) || 0)
  const columnHeights = Array.from({ length: columns }, () => 0)
  const items = heights.map((rawHeight) => {
    const height = Math.max(0, Number(rawHeight) || 0)
    let column = 0
    for (let index = 1; index < columnHeights.length; index++) {
      if (columnHeights[index] < columnHeights[column]) {
        column = index
      }
    }
    const top = columnHeights[column]
    columnHeights[column] += height + safeGap
    return { column, top, height }
  })
  const occupiedHeight = Math.max(0, ...columnHeights)
  return {
    items,
    height: occupiedHeight > 0 ? occupiedHeight - safeGap : 0
  }
}

/**
 * @param {any} item
 * @param {number} columnWidth
 * @param {number} fallbackHeight
 * @param {number} index
 * @param {readonly number[]} fallbackHeights
 */
export const estimateMasonryItemHeight = (item, columnWidth, fallbackHeight, index = 0, fallbackHeights = []) => {
  const width = Number(item?.width || 0)
  const height = Number(item?.height || 0)
  const availableWidth = Number(columnWidth || 0)
  if (width > 0 && height > 0 && availableWidth > 0) {
    return availableWidth * height / width
  }
  const safeFallbacks = Array.isArray(fallbackHeights) ? fallbackHeights : []
  const sequenceHeight = safeFallbacks.length
    ? safeFallbacks[Math.max(0, Number(index) || 0) % safeFallbacks.length]
    : fallbackHeight
  return Math.max(0, Number(sequenceHeight) || Number(fallbackHeight) || 0)
}

export const buildMasonryItemStyle = (position, columnCount, gap = 0) => {
  const columns = Math.max(1, Math.floor(Number(columnCount) || 1))
  const safeGap = Math.max(0, Number(gap) || 0)
  const column = Math.min(Math.max(0, Number(position?.column) || 0), columns - 1)
  const totalGap = safeGap * Math.max(0, columns - 1)
  const leftPercent = Number((column * 100 / columns).toFixed(6))
  const leftGap = Number((column * safeGap / columns).toFixed(6))
  return {
    width: `calc((100% - ${totalGap}px) / ${columns})`,
    left: `calc(${leftPercent}% + ${leftGap}px)`,
    top: `${Math.max(0, Number(position?.top) || 0)}px`
  }
}
